import { render, staticRenderFns } from "./EditSttConfiguration.vue?vue&type=template&id=20baab45&scoped=true&"
import script from "./EditSttConfiguration.vue?vue&type=script&lang=js&"
export * from "./EditSttConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./EditSttConfiguration.vue?vue&type=style&index=0&id=20baab45&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20baab45",
  null
  
)

export default component.exports